/** A titled block of the Next Best Action slide-out (Ways to do it, The journey, …). */
function NextBestActionSection({ title, children, testId }) {
  return (
    <section data-testid={testId} className="flex flex-col gap-3">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-content-muted">{title}</h3>
      {children}
    </section>
  );
}

export default NextBestActionSection;
